<template>
  <div class="ratio-slider">
    <div class="slider-track">
      <div
          class="slider-fill"
          :style="{ width: fillPercentage + '%', background: `${bgColor}` }"
      ></div>
    </div>
    <div v-if="!props.noNumber" class="slider-labels">
      <span>{{ current }}</span>
      <span>{{ max }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  current: {
    type: Number,
    required: true,
    default: 0
  },
  max: {
    type: Number,
    required: true,
    default: 100
  },
  noNumber: {
    type: Boolean,
    default: false
  },
  twoColor: {
    type: String,
  }
});

const fillPercentage = computed(() => {
  if (props.max <= 0) return 0;
  return Math.min(100, (props.current / props.max) * 100);
});

const app_name = computed(() => {
  return process.env.VUE_APP_PRODUCT_NAME
})

const   bgColor = computed(() => {
  if (!props.twoColor) {
    if (app_name.value === "PROTEKTOR") return 'linear-gradient(118.23deg, #B99521 -5.66%, #D6B95C 80.59%)';
    return 'linear-gradient(118.23deg, #00ADE6 -5.66%, #0086B2 80.59%)'
  } else {
    if (props.current >= props.max) {
      return props.twoColor
    } else {
      if (app_name.value === "PROTEKTOR") return 'linear-gradient(118.23deg, #B99521 -5.66%, #D6B95C 80.59%)'
      return 'linear-gradient(118.23deg, #00ADE6 -5.66%, #0086B2 80.59%)';
    }
  }
})
</script>

<style lang="scss">
.ratio-slider {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  padding: 8px 0;

  .slider-track {
    position: relative;
    width: 100%;
    height: 4px;
    background-color: #F4F5F7;
    border-radius: 4px;
    overflow: hidden;
  }

  .slider-fill {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    border-radius: 4px;
    transition: width 0.3s ease;
  }

  .slider-labels {
    display: flex;
    justify-content: space-between;
    margin-top: 4px;
    font-size: 12px;
    color: #666;
  }
}
</style>